export default [
  {
    path: '/games',
    name: 'games',
    component: () => import('@/views/game/GamesList.vue'),
  },
  {
    path: '/games/edit/:id',
    name: 'game-edit',
    component: () => import('@/views/game/GameEdit.vue'),
    meta: {
      navActiveLink: 'games',
    },
  },
  {
    path: '/games/new',
    name: 'random-game-create',
    component: () => import('@/views/game/RandomGameCreate.vue'),
  },
  {
    path: '/games/schedule-import',
    name: 'schedule-import',
    component: () => import('@/views/game/ScheduleImport.vue'),
  },
  {
    path: '/games/weeks',
    name: 'game-weeks',
    component: () => import('@/views/game/GameWeeks.vue'),
  },
  {
    path: '/games/reminders',
    name: 'game-reminders',
    component: () => import('@/views/game/GameReminders.vue'),
  },
  {
    path: '/games/builder',
    name: 'game-builder-list',
    component: () => import('@/views/game/builder/GameBuilderList.vue'),
  },
  {
    path: '/games/builder/new',
    name: 'game-builder-create',
    component: () => import('@/views/game/builder/GameBuilderView.vue'),
    meta: {
      navActiveLink: 'game-builder-list',
    },
  },
  {
    path: '/games/builder/:id',
    name: 'game-builder',
    component: () => import('@/views/game/builder/GameBuilderView.vue'),
    meta: {
      navActiveLink: 'game-builder-list',
    },
  },
]
